module.exports = __webpack_public_path__ + "static/img/13.eceb4c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/13.png
// module id = WUfg
// module chunks = 0